import { useCallback, useEffect, useRef } from 'react';
import { useAdsContext } from '../contexts/AdsContext';
const useLoadHeadScripts = () => {
    const { consent, adsEnabled, setGptReady, setAdSenseReady, adSense, headerBiddingScriptUrl, gptScriptUrl, googleTagManager, } = useAdsContext();
    const scriptsLoaded = useRef(false);
    const loadScript = useCallback(({ src = '', func = '', async = true, onLoad = () => { }, }) => {
        if (src && document.head.querySelector(`script[src='${src}']`)) {
            if (onLoad)
                onLoad();
            return;
        }
        const script = document.createElement('script');
        script.async = async;
        if (func) {
            script.innerHTML = func;
            document.head.appendChild(script);
            onLoad();
        }
        else {
            script.src = src;
            script.onload = onLoad;
            document.head.appendChild(script);
        }
    }, []);
    const initAdSense = () => {
        loadScript({
            func: adSense?.function ?? '',
            async: true,
            onLoad: setAdSenseReady,
        });
    };
    useEffect(() => {
        if (!consent || !adsEnabled || scriptsLoaded.current) {
            return;
        }
        loadScript({
            src: headerBiddingScriptUrl,
        });
        loadScript({
            src: gptScriptUrl,
            async: true,
            onLoad: setGptReady,
        });
        loadScript({
            src: adSense?.url ?? '',
            async: true,
            onLoad: initAdSense,
        });
        loadScript({
            func: googleTagManager?.function ?? '',
            async: true,
        });
        scriptsLoaded.current = true;
    }, [consent, adsEnabled]);
};
export default useLoadHeadScripts;
